module.exports = __webpack_public_path__ + "img/index-xsjl3.8cedf5ba.png";